import { ExternalLink } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";

export const BOOKS = [
  ["DraftKings", "https://sportsbook.draftkings.com"],
  ["FanDuel", "https://sportsbook.fanduel.com"],
  ["BetMGM", "https://sports.betmgm.com"],
  ["Caesars", "https://sportsbook.caesars.com"],
  ["Hard Rock Bet", "https://app.hardrock.bet"],
  ["BetRivers", "https://www.betrivers.com"],
  ["Fliff", "https://www.getfliff.com"],
  ["Bally Bet", "https://play.ballybet.com"],
  ["betPARX", "https://www.betparx.com"],
  ["bet365", "https://www.bet365.com"],
];

export const BOOK_URLS = {
  ...Object.fromEntries(BOOKS),
  "William Hill": "https://www.williamhill.com",
  Pinnacle: "https://www.pinnacle.com",
  bwin: "https://www.bwin.com",
  Unibet: "https://www.unibet.com",
};

export const BOOK_SHORT = {
  DraftKings: "DK", FanDuel: "FD", BetMGM: "MGM", Caesars: "CZR",
  "William Hill": "WH", Pinnacle: "PIN", bwin: "BWIN", Unibet: "UNI",
  "Hard Rock Bet": "HR", BetRivers: "BR", Fliff: "FLF", "Bally Bet": "BLY", betPARX: "PARX", bet365: "365",
};

// Merged sportsbook URLs — admin-set affiliate links override the defaults
export function useBookLinks() {
  const { data } = useQuery({
    queryKey: ["bookLinks"],
    queryFn: () => api.get("/book-links").then((r) => r.data),
    staleTime: 10 * 60 * 1000,
  });
  return { urls: { ...BOOK_URLS, ...(data?.links || {}) }, affiliate: data?.affiliate || [] };
}

// fire-and-forget tap-through counter (admin sees totals per book)
export const trackBookClick = (book) => {
  api.post("/book-click", { book }).catch(() => {});
};

export function BookLinks({ title = "Place it at your book", testid = "book-links" }) {
  const { urls } = useBookLinks();
  return (
    <div data-testid={testid}>
      <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold mb-2">{title}</div>
      <div className="flex flex-wrap gap-1.5">
        {BOOKS.map(([name]) => (
          <a key={name} href={urls[name]} target="_blank" rel="noreferrer" onClick={() => trackBookClick(name)}
            data-testid={`book-link-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider border border-white/15 hover:border-[#a855f7] hover:text-[#a855f7] text-neutral-300 rounded-full px-3 py-1.5 transition-colors duration-200">
            {name} <ExternalLink size={10} />
          </a>
        ))}
      </div>
      <p className="text-[10px] text-neutral-600 mt-1.5">Opens the sportsbook in a new tab — add the legs to your slip there.</p>
    </div>
  );
}
